<template>
  <section
    class="
      card
      br-10
      text-center
      container-card
      col-sm-12 col-md-6 col-xl-5
      shadow-lg
    "
    style="margin: 25px 12.5px"
  >
    <article>
      <header>
        <LogoAzienda
          class="mx-auto d-block mb-2"
          style="max-height: 40px; max-width: 40px"
        />
        <h4 class="mb-4">
          {{ LABEL.LOGIN.HOSPITAL_NAME }}
        </h4>
      </header>
      <div class="body mb-4">
        <div class="form-group">
          <h4 class="text-dark mb-2 text-center SisrAccessTitle">
            {{ LABEL.LOGIN.CARD_TITLE }}
          </h4>
        </div>
        <div class="form-group">
          <input
            :class="`form-control form-control-user ${
              errors.braccialetto ? 'SisrInputError' : ''
            }`"
            type="text"
            :placeholder="LABEL.LOGIN.INPUT_BRACELET_PLACEHOLDER"
            v-model="utente.braccialetto"
          />
        </div>
        <div class="form-group">
          <input
            :class="`form-control form-control-user ${
              errors.password ? 'SisrInputError' : ''
            }`"
            type="password"
            :placeholder="LABEL.LOGIN.INPUT_PASSWORD_PLACEHOLDER"
            @keyup.enter="access"
            v-model="utente.password"
          />
        </div>
        <div class="d-flex justify-content-center">
          <SaveButton
            :loading="loader.login"
            :text="LABEL.LOGIN.ACCESS_BTN"
            :error="errors.loginError"
            primaryIcon="sign-out-alt"
            @saving="access"
            @updateErrorValue="updateAccessError"
          />
        </div>
      </div>
      <div class="LoginDivider mb-4"></div>
      <div>
        <a
          :href="`${URL_APPLICATIVO}/${NOME_FILE_MANUALE_USO}`"
          target="_blank"
          class="Bolder"
        >
          <u>{{ LABEL.LAYOUT.MANUALE }}</u>
        </a>
      </div>
    </article>
  </section>
</template>

<script>
import { loginMixin } from "../../libs/mixins/access/index";
export default {
  mixins: [loginMixin],
};
</script>

<style lang="scss" scoped></style>
